import React, { useEffect, useRef, useState } from "react";
import { getUserDetail, setFullScriptConnected } from "../../utils/helper";
import { useDispatch } from "react-redux";
import { profilePostAction } from "../../actions/profileAction";
import useQuery from "../../pages/Register/useQuery";
import { Fullscript_OAuth_Url } from "../../constants/states";

const FullScriptOauth = () => {
  const [isBusy, setIsBusy] = useState(false);
  let query = useQuery();
  let oauthToken = query.get("code");
  const dispatch = useDispatch();

  const getAccessToken = () => {
    if (isBusy) return;
    setIsBusy(true);
    if (oauthToken) {
      var params = {
        params: {
          action: "getAccessToken",
          data: { oauthToken: oauthToken },
          token: getUserDetail()?.token,
        },
      };
    }

    dispatch(
      profilePostAction(params, (secret_token) => {
        if (secret_token) {
          setFullScriptConnected(true);
          window.location.href = "/app";
        } else {
          window.location.href = Fullscript_OAuth_Url;
        }
      })
    );
  };

  useEffect(() => {
    if (!oauthToken) {
      window.location.href = Fullscript_OAuth_Url;
    }
  }, []);

  useEffect(() => {
    if (oauthToken) {
      getAccessToken();
    }
  }, []);

  return (
    <div className="fullscript-wrapper" id="treatment-plan-container"></div>
  );
};
export default FullScriptOauth;
